import React, { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";
import { ptBR } from "date-fns/locale";


interface CustomRangeDatePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (dates: [Date | null, Date | null]) => void;
  label: string;
  disabled?: boolean;
  maxDate?: Date;
}

const CustomRangeDatePicker: React.FC<CustomRangeDatePickerProps> = ({
  startDate,
  endDate,
  onChange,
  label,
  disabled,
  maxDate
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const today = new Date();

  // Custom input embutido com forwardRef para evitar erro
  const CustomInput = forwardRef<HTMLInputElement, any>(({ value, onClick, onChange, onBlur, onFocus }, ref) => (
    <input
      type="text"
      ref={ref}
      value={value}
      onClick={onClick}
      onChange={onChange}
      onBlur={() => {
        setIsFocused(false);
        onBlur?.();
      }}
      onFocus={() => {
        setIsFocused(true);
        onFocus?.();
      }}
      placeholder="dd/mm/yyyy - dd/mm/yyyy"
      className="form-control"
      style={{
        height: "40px",
        paddingTop: "1.2rem",
        backgroundColor: "#fff"
      }}
      readOnly
    />
  ));

  return (
    <Form.Group className="position-relative w-100">
      {(startDate || endDate || isFocused) && (
        <Form.Label
          style={{
            position: "absolute",
            top: startDate || endDate || isFocused ? "1px" : "50%",
            fontSize: startDate || endDate || isFocused ? "11px" : "0.85rem",
            //fontFamily: `"system-ui", -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif`,
            left: "8px",
            color: "#8e8e93",
            transform: startDate || endDate || isFocused ? "translateY(0)" : "translateY(-50%)",
            transition: "all 0.2s ease-out",
            padding: "0 4px",
            zIndex: 2
          }}
        >
          {label}
        </Form.Label>
      )}


      <DatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        dateFormat="dd/MM/yyyy"
        isClearable
        disabled={disabled}
        wrapperClassName="w-100"
        filterDate={() => true}
        customInput={<CustomInput />}
        locale={ptBR}
      />
    </Form.Group>
  );
};

export default CustomRangeDatePicker;
